"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileMenuModal = exports.NavbarModal = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const libs_context_ios_scroll_block_1 = require("@hotelplan/libs.context.ios-scroll-block");
exports.NavbarModal = styled_components_1.default.div(({ theme }) => theme.menu.mobileMenuModal);
const MobileMenuModal = ({ children, isScrollEnable = true, }) => {
    const scrollElementRef = (0, react_1.useRef)(null);
    (0, libs_context_ios_scroll_block_1.useScrollElement)(scrollElementRef, isScrollEnable);
    // Add mobile menu modal to modals stack
    (0, components_common_modals_1.useModalStackEntry)(true);
    return (react_1.default.createElement(exports.NavbarModal, { ref: scrollElementRef, className: "navbar-modal" }, children));
};
exports.MobileMenuModal = MobileMenuModal;
//# sourceMappingURL=MobileMenuModal.js.map